import React from "react";
import "./Auth.css";

const Auth = ({ children }) => {
  return <main className="auth">{children}</main>;
};

export default Auth;
